import useThrottledFetchingWithCache from '~/composables/useThrottledFetchingWithCache';
import {getCommonStoryParams} from '~/storyblok/api/options';
import {abortController} from '~/utils';
import {getBranchStoryblokSlug} from '~/utils/branch';

export const useStoryblokServices = defineStore('storyblokServices', () => {
	const {$storyblokApi, runWithContext} = useNuxtApp();
	const cache = useThrottledFetchingWithCache<any[]>();
	let abort: AbortController['abort'] | null = null;

	function fetch(hm: string) {
		return cache.fetchItems(
			hm,
			() => {
				abort?.();
				const {signal, abort: newAbort} = abortController();
				if (import.meta.client) {
					abort = newAbort;
				}

				return $storyblokApi.getAll(
					'stories', {
						...runWithContext(getCommonStoryParams),
						starts_with: getBranchStoryblokSlug(hm, 'sluzby'),
						excluding_fields: 'body,image,carousel,listOfSections',
						level: 5,
						filter_query: {
							openingHours: {is: 'not_null'},
							component: {in: 'PageTypeRestaurant,PageTypeCoffeehouse,PageTypeButchery,PageTypeBakery,PageTypeGasStation'},
						},
					},
					undefined,
					{signal},
				);
			},
		);
	}

	return {fetch};
});
